import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Button } from '../../atoms/Button/Button';

interface AboBarProps {
  bannerText: string;
  link: string;
  price: string;
  priceExtra: string;
}

export const AboBar = ({ bannerText, link, price, priceExtra }: AboBarProps) => {
  const [showBar, setShowBar] = useState(false);

  useEffect(() => {
    if (!showBar) window.addEventListener('scroll', () => setShowBar(true));
  }, [showBar]);

  const text = bannerText?.split('{{price}}');

  if (!bannerText) return;

  return (
    <div
      className={twMerge(
        'fixed inset-x-0 -bottom-full z-50 flex w-screen items-center justify-center gap-6 bg-primary px-3 py-2 text-white transition-all duration-300 md:py-1',
        showBar && 'bottom-0',
      )}
    >
      <div className="shrink text-lg">
        {text[0]}
        <span className="font-herokid text-2xl font-medium">
          {price}
          {priceExtra}
        </span>
        {text[1]}
      </div>
      <Button
        title="zum abo"
        hasAction={false}
        link={link}
        classProps={{ root: 'm-0 py-3 px-6 inline-block pointer-events-auto min-w-fit' }}
        buttonStyle="secondary"
      />
    </div>
  );
};
